import apiClient from './apiClient';

export async function fetchAuditLogs() {
  const { data } = await apiClient.get('/audit-logs');
  return data;
}
